import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M14.4999 31.49C21.5747 31.49 27.3099 24.7608 27.3099 16.46C27.3099 8.15912 21.5747 1.42993 14.4999 1.42993C7.42517 1.42993 1.68994 8.15912 1.68994 16.46C1.68994 24.7608 7.42517 31.49 14.4999 31.49Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
